import {create} from "@/api/rest";

const password = {
  change: async (data) => await create('/password/change', data),
  requestReset: async (data) => await create('/password/request-reset', data),
};

export default password;